"use client";

import { useComboState } from "#/store/combo/comboState";

import { InstrumentsTable } from "./components/InstrumentsTable/InstrumentsTable";
import { PricesTable } from "./components/PricesTable/PricesTable";

export const ComboStateTables: React.FC = () => {
  const { comboState } = useComboState();

  return (
    <>
      {comboState === "instruments" && <InstrumentsTable />}
      {comboState === "prices" && <PricesTable />}
    </>
  );
};
